import React from 'react'
import Translation from '../Translation/cont/Translation'

class DashboardCurrentMoviesPanel extends React.Component {
    render() {
        const { isOpen, movies, onClose } = this.props

        return (
            <div className={`db-expand-panel db-expand-panel--accent${isOpen ? ' db-expand-panel--open' : ''}`}>
                <div className="db-panel-head">
                    <span className="db-panel-title db-panel-title--accent text-small-light"><Translation id="section_filter_current_movies">Current Movies</Translation></span>
                    <span className="db-panel-count db-panel-count--accent text-small-light"><Translation id="dashboard_panel_movies_count" before={`${movies.length} `}>movies</Translation></span>
                    <span className="db-panel-close text-small-light" onClick={onClose}>✕ <Translation id="button_close">Close</Translation></span>
                </div>
                <div className="db-panel-body">
                    <div className="db-panel-grid">
                        {movies.map(movie => (
                            <div key={movie.id} className="db-panel-item">
                                <div
                                    className={`db-pi-chip${movie.posterUrl ? ' db-pi-chip--has-image' : ''}${movie.isPremiere ? ' db-pi-chip--premiere' : ''}`}
                                    style={movie.posterUrl ? { backgroundImage: `url("${movie.posterUrl}")` } : undefined}
                                />
                                <div className="db-pi-body">
                                    <div className="db-pi-film text-light">{movie.title}</div>
                                    <div className="db-movie-badges">
                                        {movie.isPremiere && <span className="db-movie-badge db-movie-badge--premiere text-small-light"><Translation id="dashboard_panel_badge_premiere">Premiere</Translation></span>}
                                        {movie.isOV      && <span className="db-movie-badge db-movie-badge--ov text-small-light"><Translation id="dashboard_panel_badge_ov">OV</Translation></span>}
                                    </div>
                                    <a className="db-pi-link text-small-light" href={movie.editUrl}><Translation id="dashboard_panel_edit_link">→ Edit</Translation></a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardCurrentMoviesPanel
